module.exports = __webpack_public_path__ + "static/media/delivery-car.0207f49c.png";